// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"2393ddd0","375":"6f893883","488":"6bdb6efe"}[chunkId] + ".chunk.js";
};